import {positionToItemId, SelectQuestionState, SelectState,} from './classroom/models';
import {SelectQuestionModel} from './models';

function selectItemIds(model: SelectQuestionModel): string[] {
  const itemIds: string[] = [];

  for (let paragraphIndex = 0; paragraphIndex < model.paragraphs.length; paragraphIndex++) {
    let paragraph = model.paragraphs[paragraphIndex];
    for (let itemIndex = 0; itemIndex < paragraph.items.length; itemIndex++) {
      let item = paragraph.items[itemIndex];
      if (item.type !== 'select')
        continue;
      const itemId = positionToItemId(paragraphIndex, itemIndex);
      itemIds.push(itemId);
    }
  }

  return itemIds;
}

function defaultSelectItemState(): SelectState {
  return {
    selected: null,
    checkCount: 0,
    checked: false
  };
}

function initialState(model: SelectQuestionModel): SelectQuestionState {
  const itemIds = selectItemIds(model);
  const itemStates: { [index: string]: SelectState } = {};

  for (let itemId of itemIds)
    itemStates[itemId] = defaultSelectItemState();

  return {
    states: itemStates
  };
}

class SelectQuestionUtilsClass {
  readonly initialState = initialState;
}

export const selectQuestionUtils = new SelectQuestionUtilsClass();
